import { Link, useLocation } from "react-router-dom";
import { Briefcase, Sparkles, User, PhoneCall } from "lucide-react";

const links = [
  { to: "/candidate", label: "Jobs", icon: Briefcase },
  { to: "/returner-hub", label: "Returners", icon: Sparkles },
  { to: "/employer", label: "Hire", icon: User },
  { to: "/help", label: "Support", icon: PhoneCall },
];

export function MobileActionBar() {
  const location = useLocation();
  const hiddenRoutes = [
    "/employer/dashboard",
    "/employer/settings",
    "/candidate/dashboard",
    "/candidate/settings",
    "/admin",
  ];

  if (hiddenRoutes.some((path) => location.pathname.startsWith(path))) {
    return null;
  }

  return (
    <nav
      aria-label="Primary quick actions"
      className="fixed inset-x-0 bottom-4 z-40 mx-auto flex w-[clamp(18rem,90vw,26rem)] items-center justify-between gap-2 rounded-2xl border border-white/10 bg-[#101225]/95 p-2 shadow-[0_25px_60px_-35px_rgba(17,16,48,0.8)] backdrop-blur md:hidden"
    >
      {links.map(({ to, label, icon: Icon }) => {
        const active = location.pathname === to;
        return (
          <Link
            key={to}
            to={to}
            className={`flex flex-1 flex-col items-center gap-1 rounded-xl px-3 py-2 text-xs font-medium transition ${
              active
                ? "bg-gradient-to-r from-[#ae8625]/25 via-[#f7ef8a]/50 to-[#d2ac47]/30 text-[#f7ef8a]"
                : "text-gray-300 hover:bg-white/5 hover:text-[#f7ef8a]"
            }`}
          >
            <Icon className="h-5 w-5" aria-hidden />
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
